import { ReactNode, useState } from "react";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import JalaliUtils from "@date-io/jalaali";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import styled from "@emotion/styled";
import { InputAdornment } from "@mui/material";

// Styled DatePicker component
const CustomDatePicker = styled(DatePicker)({
    "&&": {
        padding: "1rem",
        width: "100%",
        borderRadius: ".5rem",
        border: "1px solid #8080807d",
        direction: "rtl",
        marginBottom: "1rem",
        justifyContent: "flex-end",
    },
    "&:hover": {
        border: "1px solid black",
    },
    "&:active": {
        border: `2px solid #a0a0a0`,
    },
    "&  .MuiFormHelperText-root.Mui-error": {
        textAlign: "right",
    },
    "& fieldset": {
        borderRadius: "15px",
    },
    "&&&.MuiPickersDay-current": {
        color: "rgb(201, 126, 245)"
    },
    "&& .MuiButton-textPrimary": {
        color: "rgb(201, 126, 245)"
    },
    "&.MuiFilledInput-root": {
        borderRadius: "15px",
    },
    "& .MuiSelect-iconOutlined": {
        right: "unset",
        left: ".5rem",
    },
    "&& .MuiPickersDay-daySelected:hover": {
        background: "rgb(201, 126, 245)",
    },
    "& .MuiInput-underline:before": {
        borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
        borderBottom: "none",
    },
    "& .MuiInput-underline:hover": {
        borderBottom: "none",

    },
    "& .MuiInputLabel-formControl": {
        left: "unset",
        right: "1.5rem",
        fontFamily: "'Yekan !important'",
        color: "#a0a0a0"
    },
    "& .MuiInputBase-input": {
        padding: 0,
        color: "#a0a0a0",
        fontFamily: "'Yekan !important'"
    },
});

// Custom theme for DateInput
const DateInputTheme = createTheme({
    overrides: {
        //@ts-ignore
        MuiPickersToolbar: {
            toolbar: {
                alignItems: "center !important",
                backgroundColor: "#121212",
            },
        },

        MuiPickersCalendarHeader: {
            switchHeader: {
                flexDirection: "row-reverse",
            },
        },
        MuiPickersDay: {
            daySelected: {
                backgroundColor: "rgb(201, 126, 245)",
            },
        },
    },
});
type Props = {
    placeholder?: string,
    label?: string,
    onChange: (e: any | undefined) => void,
    defaultValue?: Date | null,
    icon: ReactNode
}
const DateInput = ({ placeholder, label = "تاریخ", onChange, defaultValue = null, icon }: Props) => {
    const [selectedDate, setSelectedDate] = useState(defaultValue ?? null);
    const handleChange = (date: Date) => {
        setSelectedDate(date);
        //@ts-ignore
        onChange(date);
    };

    return (
        <ThemeProvider theme={DateInputTheme}>
            <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <CustomDatePicker
                    label={label}
                    clearable
                    okLabel="تأیید"
                    cancelLabel="لغو"
                    clearLabel="پاک کردن"
                    placeholder={placeholder}
                    format="jMMMM-jDD"
                    labelFunc={(date: any) =>
                        date ? date.format("jYYYY/jMM/jDD") : placeholder
                    }
                    value={selectedDate}
                    onChange={handleChange}
                    InputProps={{
                        style: {
                            textDecoration: "none",
                            border: "none",
                            padding: 0,
                        },
                        endAdornment: (
                            <InputAdornment position="end">
                                {icon}
                            </InputAdornment>
                        ),
                    }}
                />
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    );
};

export default DateInput;
